export default "__VITE_PUBLIC_ASSET__dba04b42__"